import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

export default function CalendarComponent({ selectedDate, setSelectedDate }) {
  // Initialize selectedDate with a valid date, or fallback to null if invalid
  const [modalSelectedDate, setModalSelectedDate] = useState(
    selectedDate ? dayjs(selectedDate) : null
  );

  useEffect(() => {
    if (modalSelectedDate && modalSelectedDate.isValid()) {  // Check if selectedDate is valid
      console.log("selectedDate:", modalSelectedDate.format("YYYY-MM-DD")); // Output date in YYYY-MM-DD format
      setSelectedDate(modalSelectedDate.format("YYYY-MM-DD"));
    }
  }, [modalSelectedDate, setSelectedDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 0, m: 0 }}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={modalSelectedDate}
          onChange={(newValue) => setModalSelectedDate(newValue)}
          openTo="day"
          showToolbar={false}
          slotProps={{
            calendarHeader: {
              sx: { mt: 0, mb: 0, py: 0 }, // Remove top/bottom margin and padding
            },
            root: {
              sx: { m: 0, p: 0 }, // Remove margin/padding from picker root
            },
          }}
          sx={{
            '.MuiPickersCalendarHeader-root': { mt: 0, mb: 0, py: 0 },
            '.MuiPickersBasePicker-root': { m: 0, p: 0 },
            '.MuiPickersSlideTransition-root': { minHeight: '230px' }, // Set min-height to 230px
            m: 0,
            p: 0,
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
